function useCounter(form_id, field_id, operation) {
    var field = document.getElementById(field_id),
        field_id = field.id,
        field_step = parseInt(field.step) || 1,
        field_min = parseInt(field.min) || 1,
        field_max = parseInt(field.max),
        field_val = parseInt(field.value);

    field_val = isNaN(field_val) ? 0 : field_val;

    if (operation == 'minus') {
        field_val = field_val - field_step;
    }
    if (operation == 'plus') {
        field_val = field_val + field_step;
    }

    field_val = field_val < field_min ? field_min : field_val;
    if (!isNaN(field_max)) {
        field_val = field_val > field_max ? field_max : field_val;
    }

    field.value = field_val;

    if (typeof checkPcsLength === 'function') {
        checkPcsLength(field);
    }

    if (field.classList.contains('validated')) {
        checkForm(form_id, 1);
    }

    if (field.classList.contains('check-basket-amount-change')) {
        checkBasketAmount(field, field_val);
    }
}

function setCounter() {
    const buttons = document.querySelectorAll('.counter-box__button:not(.button--listening)');

    for (let i = 0; i < buttons.length; ++i) {
        let button = buttons[i],
            field = button.parentNode.previousElementSibling,
            field_id = field.id,
            form_id = field.form.id,
            operation = button.classList.contains('button--minus') ? 'minus' : button.classList.contains('button--plus') ? 'plus' : false;

        // Workaround preventing redundant eventListeners adding in checkForm function - counter inputs have valid value set in HTML
        if (field.classList.contains('validate')) {
            field.classList.add('validated');
        }

        button.addEventListener('click', function() {
            useCounter(form_id, field_id, operation);
        });
        button.classList.add('button--listening');
    }
}

setCounter();